<template>
    <div class="modal fade" id="rejection-reason-modal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="generate-pdf-modal-title">
                        {{ $lang('Powód odrzucenia pracy zdalnej') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <label class="h6 mb-3" for="rejection_reason">{{$lang('Proszę podać powód odrzucenia pracy zdalnej:')}}</label>
                    <textarea class="form-control" name="rejection_reason" id="rejection_reason"
                              v-model="reason" rows="3"></textarea>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">{{ $lang('Anuluj') }}</button>
                    <button @click="reject" type="button" class="btn btn-primary" data-dismiss="modal" :disabled="!valid">
                        {{ $lang('Odrzuć pracę zdalną') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "../../mixins/event-bus";

export default {
    name: "remote-rejection-modal",
    data() {
        return {
            remoteId: null,
            reason: null,
        }
    },
    mounted() {
        EventBus.$on('openRejectRemoteJobModal', (value) => {
            this.remoteId = value.remoteId;
            this.reason = null;
        });
    },
    computed: {
      valid() {
          return (this.reason !== null && this.reason !== '');
      }
    },
    methods: {
        reject() {
            EventBus.$emit('rejectRemoteJob', {
                remoteId: this.remoteId,
                reason: this.reason
            });
        }
    }
}
</script>

<style scoped>

</style>
